// script.js para el menu hamburguesa

// Seleccionamos los elementos necesarios
const menuToggle = document.querySelector('.menu-toggle');
const menu = document.querySelector('.menu');

// Añadimos el evento al botón de la hamburguesa
menuToggle.addEventListener('click', () => {
  menu.classList.toggle('active'); // Activa o desactiva la clase "active"
});




// script.js para el background color del menu fijo

// Asegurar que el script se ejecuta después de cargar el DOM
document.addEventListener('DOMContentLoaded', () => {
  // Seleccionar el elemento <header>
  const header = document.querySelector('header');

  // Verificar que el header existe
  if (header) {
    // Escuchar el evento de scroll
    window.addEventListener('scroll', () => {
      const scrollThreshold = window.innerHeight; // Altura de la primera pantalla

      // Si el scroll supera el umbral, añadir la clase
      if (window.scrollY > scrollThreshold) {
        header.classList.add('scrolled');
      } else {
        // Si no, quitar la clase
        header.classList.remove('scrolled');
      }
    });
  } else {
    console.error('No se encontró la etiqueta <header>');
  }
});
